var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('check-selector-collapse',{attrs:{"icon":_vm.icon,"label":_vm.label,"options":_vm.tiposOpciones},on:{"checked":_vm.handleChecked}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }